class CategoryOpener extends HTMLElement {
  constructor() {
    super();
    this.subcategory = this.nextElementSibling;
    this.subcategoryClose = this.subcategory.querySelector(
      ".mobile-header-back"
    );
    this.subcategoryClose.addEventListener("click", () => {
      this.subcategory.classList.remove("active");
    });
    this.addEventListener("click", () => {
      this.subcategory.classList.add("active");
    });
  }
}

class MobileMenu extends HTMLElement {
  constructor() {
    super();
    this.hamburger = this.querySelector(".hamburger-container");
    this.menu = this.querySelector(".mobile-menu-container");
    this.closeButtons = this.menu.querySelectorAll(".mobile-header-close");
    this.subcategoryOpeners = this.querySelectorAll(".category-opener .category-button");
    this.backButtons = this.menu.querySelectorAll(".mobile-header-back")

    this.hamburger.addEventListener("click", () => {
      this.openMenu();
    });

    this.closeButtons.forEach((button) => {
      button.addEventListener("click", () => {
        this.closeMenu();
      });
    });

    this.subcategoryOpeners.forEach((opener) => {
      opener.addEventListener("click", () => {
        this.openSubcategory(opener);
        
      });
    });

    this.backButtons.forEach((button) => {
      button.addEventListener("click", ()=>{
        this.closeSubcategory(button)
      })
    })
  }
  openSubcategory(opener) {
    const subcategory = opener.nextElementSibling;
    subcategory.classList.add("active");
  }
  closeSubcategory(button) {
    const subcategory = button.parentElement.parentElement;
    subcategory.classList.remove("active");
  }
  openMenu() {
    this.menu.classList.add("active");
  }
  closeMenu() {
    this.menu.classList.remove("active");
  }
}
customElements.define("mobile-menu", MobileMenu);
